import React from 'react';

import { Card, CardContent, Grid, ListItemText } from '@material-ui/core';

const InfoCard = ({ market, merchants, merchantCount }) => (
    <Card elevation={1}>
        <CardContent style={{ padding: '0px 14px' }}>
            <ListItemText
                primary={market.libelleMarche}
                secondary={
                    <Grid container justifyContent="space-between" justify="space-between">
                        <Grid item>{market.jour}</Grid>
                        <Grid item>
                            {merchants.length}/{merchantCount} titulaires -{' '}
                            <strong>{market.nbPlaces} places</strong>
                        </Grid>
                    </Grid>
                }
            />
        </CardContent>
    </Card>
);

export default InfoCard;
